import { getSubdomain } from 'helpers/global';
import { useSelector } from 'react-redux';

function useWhiteLabel() {
  const { me } = useSelector((state) => state.auth);

  const subdomain = getSubdomain();

  return {
    isWhiteLabelTeam: me?.team.whiteLabelAccount && me?.team.whiteLabelSubdomain === subdomain
  };
}

export default useWhiteLabel;
